export * from "./SkeletonText";
